import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScreenSizeService } from "../../services/screen-size.service";

@Component({
  selector: 'app-generic-message',
  templateUrl: './generic-message.component.html',
  styleUrls: ['./generic-message.component.css']
})
export class GenericMessage {
  isMobile: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<GenericMessage>,
    private screenSizeService: ScreenSizeService,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string }
  ) { }

  ngOnInit(): void {
    this.screenSizeService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
